import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

const CentrarMapa = ({ lat, lng, zoom }) => {
    const map = useMap();

    useEffect(() => {
        if (lat && lng) {
            map.flyTo([lat, lng], zoom  , {
                animate: true,
                duration: 1.5,
            });
        }
    }, [lat, lng, map]);

    return null;
};

export default CentrarMapa;


